var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7955 11.3256L6.72054 1.89438C6.68899 1.86954 6.65107 1.8541 6.61114 1.84984C6.57121 1.84558 6.53088 1.85266 6.4948 1.87029C6.45871 1.88791 6.42833 1.91535 6.40714 1.94946C6.38595 1.98357 6.37481 2.02297 6.375 2.06313V4.13366C6.375 4.26491 6.43661 4.39081 6.5384 4.47116L16.1813 12.0006L6.5384 19.5301C6.43393 19.6104 6.375 19.7363 6.375 19.8676V21.9381C6.375 22.1176 6.58125 22.2167 6.72054 22.1069L18.7955 12.6756C18.8982 12.5956 18.9812 12.4932 19.0383 12.3762C19.0954 12.2592 19.1251 12.1308 19.1251 12.0006C19.1251 11.8705 19.0954 11.742 19.0383 11.6251C18.9812 11.5081 18.8982 11.4057 18.7955 11.3256Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.fd70e79e9e4be27d8418c64711d24a8e.svg";
export { ForwardRef as ReactComponent };